"use strict";

/**
* Диалог создания документа.
*
* @class WebAccess.components.dialogs.CreateDocument
* @since 5.2.0.1100
* @extends WebAccess.components.dialogs.BaseDialog
*
* @example
* // Открытие диалогового окна «Создание документа».
* var dialog  = new WA.CMP.dialogs.CreateDocument()
* dialog.bind('ok', function(data) {
*   alert('ok')
* });
* dialog.bind('create', function(document) {
*  document.open();
* });
* dialog.show()
*/

/**
 * Событие срабатывает при открытии окна создания документа.
 * @event  WebAccess.components.dialogs.CreateDocument#open
 */

/**
 * Событие срабатывает после загрузки содержимого окна создания документа.
 * @event  WebAccess.components.dialogs.CreateDocument#loaded
 */

/**
 * Событие срабатывает после нажатия на кнопку «Создать документ».
 * @event  WebAccess.components.dialogs.CreateDocument#ok
 */

/**
 * Событие срабатывает после создания документа.
 * @event  WebAccess.components.dialogs.CreateDocument#create
 * @param {Link} doc Ссылка на созданный документ
 *
 */

(function (global) {
  var CreateDocument = global.BaseDialog.extend({
    title: L("MODAL_DIALOG_SELECT_ITEMS"),
    width: 600,
    height: 'auto',
    className: "CreateDocument",
    mode: 'create',
    _jWindow: null,
    _html: "",
    _handlers: {},
    _jSelectedItemsTable: null,
    _jAvailableItemsList: null,
    _lastFilterValue: null,
    _displayOptions: false,
    _datatable: null,
    isShowCancelButton: true,
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    init: function (settings) {
      var me = this;

      this._super(settings);    
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Создание html разметки и контейнеров
    * @private
    */
    _preInit: function () {
      /** Вернем все, что навыбирали в ok callback, и еще выбросим событие с выбранными данными 
     * @ignore
     */
      var me = this;
      this.ok = this.ok.override(
        function () {
          var rnd = Math.floor(Math.random() * 10000).toString();
          var jWindow = me._jWindow;
          var formIsValid = me.isFormValid(jWindow);

          if (formIsValid && CheckFileSize(jWindow.find('form input[type="file"]')[0], jWindow.data('error'))) {
            jWindow.find('form').submit();
            return false;
          }
          else if (!formIsValid) {
            jWindow.data('error')(L('NOT_ALL_REQUIRED_FIELDS_FILLED'));
            return false;
          }
        }
      );
    },

    /**
    * Иницииализация jQuery объектов и навешивание на них событий, 
    * функция вызывается когда модальное окно и все его элементы загружены.
    * @private
    */
    _postInit: function () {
      var me = this;
      var jWindow = this._jWindow;
      jWindow.data('success', (res) => {
        const linkArr = [];
        const resArr = res.split(';');
        resArr.forEach((item) => {
          let url = new WA.URL(item);
          let id = url.getParam('id');
          let link = new WA.Link(id, OBJECT_TYPE.EDOCUMENT);
          link.isNew = true;
          linkArr.push(link);
        });
        me.fire('create', linkArr[0]);
        me.fire('createMulti', linkArr);
        me.close();

      }).data('error', (res) => {
        me.inlineHint.show(res, null, MESSAGE_TYPE.ERROR, INLINE_HINT_PRIORITY.PRIMARY);
        me.fire('error', res);
      });

      me.initCreateNewDocumentControl(jWindow);

      me.fire('loaded');
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
 
    initCreateNewDocumentControl: function () {
      var me = this;
      me._jWindow.find('[name="is_from_file"]').change(function () {
        if (me._jWindow.find('#radio_from_file').is(':checked')) {
          $('#new_div_file input').removeAttr('disabled');
          setTimeout(function () { //setTimeout нужно т.к. инициализация "выбора из справочника" проходит немного позже этого события.
            $('#new_div_app input').SetEnabled();
            $('#new_div_template input').SetDisabled();
          }, 50);
          $('#new_div_file, #new_div_app').removeClass('field_disabled');
          $('#new_div_template').addClass('field_disabled');
        } else {
          $('#new_div_file input').attr('disabled', 'disabled');
          setTimeout(function () { //setTimeout нужно т.к. инициализация "выбора из справочника" проходит немного позже этого события.
            $('#new_div_app input').SetDisabled();
            $('#new_div_template input').SetEnabled();
          }, 50);
          $('#new_div_file, #new_div_app').addClass('field_disabled');
          $('#new_div_template').removeClass('field_disabled');
        }
      }).trigger('change');
      if ($.ipad && !WA.ENV.isAndroid()) {
        me._jWindow.find('#radio_from_file').attr('disabled', 'disabled');
      }
    },

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    isFormValid: function (jWindow) {
      if (!jWindow.find('input[name=refVid]').val()) return false;
      if (!jWindow.find('input[name=refCardType]').val()) return false;
      if (this.mode == 'copy') return true;
      if ($('#radio_from_template').is(':checked')) {
        if (!jWindow.find('input[name=refTempl]').val()) return false;
      } else {
        if (!jWindow.find('input[type=file]').val()) return false;
        if (!jWindow.find('input[name=refApp]').val()) return false;
      }
      return true;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Вызывается сразу после открытия модалки, навешивает события на эелементы списков
    * @private
    */
    _initEvents: function () {
      this._initSelectedItemsEvents();
      this._InitAvailableItemsListEvents();
      this._initFilterInputEvents();

      this.bind("itemSelect", function () {
        this.isSelectionChanged = true;
      });
      this.bind("itemUnSelect", function () {
        this.isSelectionChanged = true;
      });

      this._initExtraEvents();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//  
    
    show: function (opt_mode) {
      opt_mode = opt_mode || this.mode;
      var me = this;
      me._preInit();
      var title;

      switch (opt_mode) {
        case "template":
          title = L("CREATE_DOCUMENT_FROM_TEMPLATE");
          break;
        case "file":
          title = L("CREATE_DOCUMENT_FROM_FILE");
          break;
        case "create":
          title = L("CREATE_DOCUMENT");
          break;
        case "copy":
          title = L("COPY_DOCUMENT");
          break;
        default:
          title = L("CREATE_DOCUMENT");
          break;
      }

      me.okText = opt_mode == "copy" ? L("COPY") : L("CREATE");


      me._super();
      me.setSpinner();

      var folder_id = GetParamInURL("id");
      if (!folder_id) folder_id = FavoritesFolderID;
      var data = {
        Mode: opt_mode,
        FolderID: folder_id
      };

      WA.SRV.call("/ModalWindow.asmx/Create", { ControlName: "new_document", Params: $.toJSON(data) }).done(function (data) {
        me.setTitle(title);
        me.setHtml('<div id="modal_window">' + data.html + '</div>');
        me._jWindow = $('#modal_window');
        me._postInit();
        moveOpenedDialogToCenter();
      }).fail(function () {
        me.close();
      });
      return this;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  });

  /**
  * Возможность перезаписи функций, с возможностью запуска родительской функции.  
  * @inner
  */
  Function.prototype.override = function (func) {
    var superFunction = this;
    return function () {
      this.superFunction = superFunction;
      return func.apply(this, arguments);
    };
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
 
  global.CreateDocument = CreateDocument;
})(window.WebAccess.components.dialogs);